<div class="flex h-full min-h-0 w-full flex-col">
  <!-- header -->
  <div class="flex items-start justify-between px-6" [ngClass]="shortScreen ? 'pt-3 pb-2' : 'pt-6 pb-4'">
    <div class="flex min-w-0 items-start gap-3">
      <mat-icon class="text-primary mt-1 shrink-0" fontSet="material-icons-outlined">local_shipping</mat-icon>
      <div class="min-w-0">
        <h2 class="text-xl font-bold">{{ 'DOCUMENT_GENERATE.ROUTE_SPLIT_MODAL.TITLE' | t }}</h2>
        @if (!shortScreen) {
        <p class="text-secondary mt-1 text-sm leading-relaxed">
          @if (data.splitByWindow) {
          {{ 'DOCUMENT_GENERATE.ROUTE_SPLIT_MODAL.SUBTITLE_WINDOW' | t: { count: documents.length } }}
          } @else if (showsDocumentLabels) {
          {{ 'DOCUMENT_GENERATE.ROUTE_SPLIT_MODAL.SUBTITLE_SPLIT' | t: { count: documents.length } }}
          } @else {
          {{ 'DOCUMENT_GENERATE.ROUTE_SPLIT_MODAL.SUBTITLE' | t }}
          }
        </p>
        }
      </div>
    </div>
    <button mat-icon-button type="button" class="shrink-0" (click)="cancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- maestro y detalle: la lista crece con el número de documentos, el detalle no -->
  <div class="flex min-h-0 flex-1 flex-col border-t md:flex-row">
    <!-- móvil: el documento se elige en un desplegable -->
    @if (showsDocumentLabels) {
    <div class="shrink-0 border-b px-4 py-3 md:hidden">
      <mat-form-field class="w-full" subscriptSizing="dynamic">
        <mat-label>{{ 'DOCUMENT_GENERATE.SPLIT_MODAL.DOCUMENT' | t }}</mat-label>
        <mat-select [value]="selectedIndex" (selectionChange)="select($event.value)"
          panelClass="dg-wrap-panel">
          <mat-select-trigger>
            @if (selected) {
            <span class="flex flex-wrap items-center gap-x-2 gap-y-0.5">
              <span class="font-semibold">{{ selected.label }}</span>
              @if (!hasRoute(selected)) {
              <mat-icon class="icon-size-4 text-amber-600 dark:text-amber-400"
                fontSet="material-icons-outlined">warning</mat-icon>
              }
              <span class="text-secondary text-xs">
                {{ 'DOCUMENT_GENERATE.SPLIT_MODAL.LINES_COUNT' | t: { count: lineCount(selected) } }} ·
                {{ data.currency }}&nbsp;{{ selected.summary.total | dgNumber }}
              </span>
            </span>
            }
          </mat-select-trigger>
          @for (doc of documents; track doc.index) {
          <mat-option [value]="$index">
            <span class="flex flex-col gap-0.5 py-1">
              <span class="flex flex-wrap items-center gap-1.5">
                <span class="font-semibold">{{ doc.label }}</span>
                @if (!doc.candidates.length) {
                <mat-icon class="icon-size-4 text-amber-600 dark:text-amber-400"
                  fontSet="material-icons-outlined">warning</mat-icon>
                }
              </span>
              @if (doc.warehouseLabel) {
              <span class="text-secondary text-xs uppercase">{{ doc.warehouseLabel }}</span>
              }
              <span class="flex items-center gap-2 text-xs">
                <span class="text-secondary">
                  {{ 'DOCUMENT_GENERATE.SPLIT_MODAL.LINES_COUNT' | t: { count: lineCount(doc) } }}
                </span>
                <span class="font-semibold">{{ data.currency }}&nbsp;{{ doc.summary.total | dgNumber }}</span>
              </span>
            </span>
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <!-- desde md: lista de documentos como panel lateral -->
    <div class="hidden shrink-0 overflow-auto border-b md:block md:max-h-none md:w-72 md:border-b-0 md:border-r">
      @for (doc of documents; track doc.index) {
      <button type="button" class="w-full border-b px-4 py-3 text-left transition-colors"
        [class.bg-primary-50]="$index === selectedIndex"
        [class.dark:bg-primary-900]="$index === selectedIndex"
        [class.hover:bg-gray-50]="$index !== selectedIndex"
        [class.dark:hover:bg-gray-800]="$index !== selectedIndex"
        (click)="select($index)">
        <div class="flex items-center justify-between gap-2">
          <span class="flex min-w-0 items-center gap-1">
            <span class="truncate font-semibold" [class.text-primary]="$index === selectedIndex">
              {{ doc.label }}
            </span>
            @if (!doc.candidates.length) {
            <mat-icon class="icon-size-4 shrink-0 text-amber-600 dark:text-amber-400"
              fontSet="material-icons-outlined"
              [matTooltip]="'DOCUMENT_GENERATE.ROUTE_SPLIT_MODAL.WITHOUT_ROUTE' | t">warning</mat-icon>
            }
          </span>
        </div>
        @if (doc.warehouseLabel) {
        <div class="text-secondary mt-0.5 truncate text-xs uppercase" [matTooltip]="doc.warehouseLabel">
          {{ doc.warehouseLabel }}
        </div>
        }
        <!-- ruta elegida -->
        <div class="mt-1 flex items-center gap-1 text-xs">
          @if (routeName(doc)) {
          <mat-icon class="text-secondary icon-size-4" fontSet="material-icons-outlined">local_shipping</mat-icon>
          <span class="truncate font-medium">{{ routeName(doc) }}</span>
          } @else {
          <span class="text-secondary">{{ 'DOCUMENT_GENERATE.ROUTE_SPLIT_MODAL.NO_ROUTE_ASSIGNED' | t }}</span>
          }
        </div>
        <!-- líneas y total del documento -->
        <div class="mt-1 flex items-center justify-between gap-2 text-xs">
          <span class="text-secondary">
            {{ 'DOCUMENT_GENERATE.SPLIT_MODAL.LINES_COUNT' | t: { count: lineCount(doc) } }}
          </span>
          <span class="font-semibold">{{ data.currency }}&nbsp;{{ doc.summary.total | dgNumber }}</span>
        </div>
      </button>
      }
    </div>
    }

    <!-- detalle del documento seleccionado -->
    <div class="flex min-h-0 min-w-0 flex-1 flex-col">
      @if (selected) {
      <!-- encabezado del documento -->
      <div class="flex flex-wrap items-center justify-between gap-2 px-6 py-4">
        <h3 class="text-base font-bold">
          {{ 'DOCUMENT_GENERATE.SPLIT_MODAL.DOCUMENT_OF' | t: { index: selectedIndex + 1, total: documents.length } }}
        </h3>
        @if (selected.warehouseLabel) {
        <span class="inline-flex items-center gap-1 rounded-full bg-gray-100 px-2 py-0.5 text-xs font-medium dark:bg-gray-700">
          <mat-icon class="icon-size-4">warehouse</mat-icon>
          {{ selected.warehouseLabel }}
        </span>
        }
      </div>

      <!-- por qué quedó separado del resto -->
      @if (selected.splitReasons?.length) {
      <div class="flex flex-wrap items-center gap-2 px-6 pb-3">
        <span class="text-secondary text-xs">{{ 'DOCUMENT_GENERATE.SPLIT_MODAL.SPLIT_REASON' | t }}</span>
        @for (reason of selected.splitReasons; track reason) {
        <span class="inline-flex items-center rounded-full bg-blue-50 px-2 py-0.5 text-xs font-medium text-blue-700 dark:bg-blue-900/40 dark:text-blue-300">
          {{ reasonLabel(reason) }}
        </span>
        }
        @if (selected.daysLabel) {
        <span class="text-secondary text-xs">
          {{ 'DOCUMENT_GENERATE.SPLIT_MODAL.ALLOWED_DAYS' | t }}: {{ selected.daysLabel }}
        </span>
        }
      </div>
      }

      <!-- información de la ruta elegida -->
      <div class="border-t px-6 py-3">
        @if (selectedCandidate) {
        <div class="flex flex-wrap items-center gap-x-4 gap-y-2">
          <span class="flex items-center gap-1.5 font-semibold uppercase">
            <mat-icon class="text-primary icon-size-5" fontSet="material-icons-outlined">local_shipping</mat-icon>
            {{ selectedCandidate.name }}
          </span>
          @if (selectedCandidate.trip) {
          <span class="text-secondary flex items-center gap-1 text-sm">
            <mat-icon class="icon-size-4" fontSet="material-icons-outlined">event_available</mat-icon>
            {{ selectedCandidate.trip.dateHourStartTeoric | date:'dd/MM/yyyy HH:mm' }}
          </span>
          }
          @if (selected.estimatedDelivery && !selectedCandidate.trip) {
          <span class="text-secondary flex items-center gap-1 text-sm">
            <mat-icon class="icon-size-4" fontSet="material-icons-outlined">event_available</mat-icon>
            {{ 'DOCUMENT_GENERATE.ROUTE_SPLIT_MODAL.ESTIMATED_DELIVERY' | t }}:
            {{ selected.estimatedDelivery | date:'dd/MM/yyyy' }}
          </span>
          }
        </div>
        } @else if (selected.candidates.length) {
        <div class="text-secondary flex items-center gap-2 text-sm">
          <mat-icon class="icon-size-5" fontSet="material-icons-outlined">local_shipping</mat-icon>
          {{ 'DOCUMENT_GENERATE.ROUTE_SPLIT_MODAL.NO_ROUTE_ASSIGNED' | t }}
        </div>
        } @else {
        <div class="flex items-start gap-2 rounded-xl border border-amber-300 bg-amber-50 px-4 py-3 dark:border-amber-700 dark:bg-amber-950">
          <mat-icon class="icon-size-5 shrink-0 text-amber-600 dark:text-amber-400"
            fontSet="material-icons-outlined">warning</mat-icon>
          <span class="text-sm leading-relaxed text-amber-900 dark:text-amber-100">
            {{ 'DOCUMENT_GENERATE.ROUTE_SPLIT_MODAL.NO_CANDIDATES' | t }}
          </span>
        </div>
        }
      </div>

      <!-- rutas disponibles: colapsable, con su propio desplazamiento -->
      @if (selected.candidates.length) {
      <div class="border-t">
        <button type="button"
          class="flex w-full items-center justify-between gap-2 px-6 py-2.5 text-left transition-colors hover:bg-gray-50 dark:hover:bg-gray-800"
          (click)="toggleRoutes()">
          <span class="flex items-center gap-2 text-sm font-semibold">
            <mat-icon class="icon-size-5 text-secondary" fontSet="material-icons-outlined">alt_route</mat-icon>
            {{ 'DOCUMENT_GENERATE.ROUTE_SPLIT_MODAL.AVAILABLE_ROUTES' | t: { count: selected.candidates.length } }}
          </span>
          <mat-icon class="text-secondary">{{ routesExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
        </button>
        @if (routesExpanded) {
        <div class="max-h-[13rem] overflow-auto border-t px-6 py-3">
          <mat-radio-group class="flex flex-col gap-2" [(ngModel)]="selectedByDocument[selected.index]">
            @for (candidate of selected.candidates; track candidate._id) {
            <div class="rounded-xl border p-3 transition-colors"
              [class.border-primary]="selectedByDocument[selected.index] === candidate._id"
              [class.bg-primary-50]="selectedByDocument[selected.index] === candidate._id">
              <mat-radio-button [value]="candidate._id" class="w-full">
                <div class="flex flex-col gap-1">
                  <span class="font-bold uppercase">{{ candidate.name }}</span>
                  @if (candidate.trip) {
                  <span class="text-sm">
                    {{ 'DOCUMENT_GENERATE.ROUTE_SPLIT_MODAL.TRIP_DELIVERY' | t }}
                    <b>{{ candidate.trip.dateHourStartTeoric | date:'dd/MM/yyyy HH:mm' }}</b>
                    · {{ 'DOCUMENT_GENERATE.ROUTE_SPLIT_MODAL.TRIP_LOAD' | t }}
                    <b>{{ candidate.trip.loadDateTime | date:'dd/MM/yyyy HH:mm' }}</b>
                  </span>
                  }
                  @if (candidate.alternativeTrips.length) {
                  <span class="text-secondary text-xs">
                    {{ 'DOCUMENT_GENERATE.ROUTE_SPLIT_MODAL.ALTERNATIVE_TRIPS' | t: { count: candidate.alternativeTrips.length } }}
                  </span>
                  }
                </div>
              </mat-radio-button>
            </div>
            }
            @if (data.canGenerateWithoutRoute) {
            <div class="rounded-xl border p-3 transition-colors"
              [class.border-primary]="!selectedByDocument[selected.index]"
              [class.bg-primary-50]="!selectedByDocument[selected.index]">
              <mat-radio-button [value]="null" class="w-full">
                <span class="font-medium">{{ 'DOCUMENT_GENERATE.ROUTE_SPLIT_MODAL.NO_ROUTE_OPTION' | t }}</span>
              </mat-radio-button>
            </div>
            }
          </mat-radio-group>
        </div>
        }
      </div>
      }

      <!-- artículos del documento, móvil: tarjetas -->
      <div class="min-h-0 flex-1 overflow-auto border-t p-3 md:hidden">
        <div class="flex flex-col gap-3">
          @for (item of purchasedItems(selected); track item.lineId) {
          <div class="flex flex-col rounded-xl border bg-card p-3">
            <div class="flex min-w-0 flex-col">
              <span class="text-secondary text-xs">{{ 'DOCUMENT_GENERATE.SPLIT_MODAL.LINE_NUMBER' | t: { index: $index + 1 } }}</span>
              <span class="text-primary font-semibold">{{ item.code }}</span>
              <span class="text-sm uppercase">{{ item.name }}</span>
              @if (warehouseLabel(item)) {
              <span class="text-secondary text-xs">{{ 'DOCUMENT_GENERATE.SPLIT_MODAL.WAREHOUSE_PREFIX' | t }} {{ warehouseLabel(item) }}</span>
              }
            </div>
            <div class="mt-3 grid grid-cols-2 gap-x-4 gap-y-2 border-t pt-3 text-sm">
              <div class="col-span-2 flex items-center justify-between gap-2">
                <span class="text-secondary">{{ 'DOCUMENT_GENERATE.COLUMNS.QUANTITY' | t }}</span>
                <span class="font-semibold">{{ quantityText(item) }}</span>
              </div>
              <div class="col-span-2 flex items-center justify-between gap-2">
                <span class="text-secondary shrink-0">{{ 'DOCUMENT_GENERATE.COLUMNS.SALE_UOM' | t }}</span>
                <div class="flex min-w-0 flex-col items-end">
                  <span class="min-w-0 truncate" [matTooltip]="item.unitLabel">{{ item.unitLabel }}</span>
                  @if (altUnits(item); as alt) {
                  <span class="text-secondary text-xs">{{ 'DOCUMENT_GENERATE.COLUMNS.BASE_UOM_LABEL' | t: { value: (alt.umbQty | dgNumber: 'stock') + ' ' + alt.umbCode } }}</span>
                  @if (alt.umsQty != null) {
                  <span class="text-secondary text-xs">{{ 'DOCUMENT_GENERATE.COLUMNS.SECONDARY_UOM_LABEL' | t: { value: (alt.umsQty | dgNumber: 'stock') + ' ' + alt.umsCode } }}</span>
                  }
                  @if (alt.umpQty != null) {
                  <span class="text-secondary text-xs">{{ 'DOCUMENT_GENERATE.COLUMNS.PACKAGING_UOM_LABEL' | t: { value: (alt.umpQty | dgNumber: 'stock') + ' ' + alt.umpCode } }}</span>
                  }
                  }
                </div>
              </div>
              <div class="col-span-2 flex items-center justify-between gap-2 border-t pt-2">
                <span class="text-secondary font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.TOTAL' | t }}</span>
                <span class="text-primary text-base font-bold">{{ data.currency }}&nbsp;{{ rowTotal(item) | dgNumber }}</span>
              </div>
            </div>
          </div>
          } @empty {
          <div class="text-secondary flex h-24 items-center justify-center text-sm">
            {{ 'DOCUMENT_GENERATE.SPLIT_MODAL.EMPTY' | t }}
          </div>
          }
        </div>
      </div>

      <!-- artículos del documento, desktop: tabla con desplazamiento propio -->
      <div class="hidden min-h-0 flex-1 overflow-auto border-t md:block">
        <table class="w-full min-w-[680px] border-collapse text-sm">
          <thead class="sticky top-0 z-10 bg-gray-50 dark:bg-gray-800">
            <tr class="text-secondary text-left">
              <th class="w-px whitespace-nowrap px-3 py-3 text-center font-medium">{{ 'DOCUMENT_GENERATE.SPLIT_MODAL.COLUMN_NUMBER' | t }}</th>
              <th class="px-4 py-3 font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.PRODUCT' | t }}</th>
              <th class="px-4 py-3 text-center font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.QUANTITY' | t }}</th>
              <th class="px-4 py-3 font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.SALE_UOM' | t }}</th>
              <th class="px-4 py-3 text-right font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.TOTAL' | t }}</th>
            </tr>
          </thead>
          <tbody>
            @for (item of purchasedItems(selected); track item.lineId) {
            <tr class="border-t">
              <td class="w-px whitespace-nowrap px-3 py-3 text-center">{{ $index + 1 }}</td>
              <td class="px-4 py-3">
                <div class="flex flex-col">
                  <span class="text-primary font-semibold">{{ item.code }}</span>
                  <span class="uppercase">{{ item.name }}</span>
                  @if (warehouseLabel(item)) {
                  <span class="text-secondary text-xs">{{ 'DOCUMENT_GENERATE.SPLIT_MODAL.WAREHOUSE_PREFIX' | t }} {{ warehouseLabel(item) }}</span>
                  }
                </div>
              </td>
              <td class="px-4 py-3 text-center">{{ quantityText(item) }}</td>
              <td class="px-4 py-3 text-left">
                <div class="flex flex-col items-start">
                  <span class="inline-block max-w-[90px] truncate align-middle" [matTooltip]="item.unitLabel">
                    {{ item.unitLabel }}
                  </span>
                  @if (altUnits(item); as alt) {
                  <span class="text-secondary whitespace-nowrap text-xs">{{ 'DOCUMENT_GENERATE.COLUMNS.BASE_UOM_LABEL' | t: { value: (alt.umbQty | dgNumber: 'stock') + ' ' + alt.umbCode } }}</span>
                  @if (alt.umsQty != null) {
                  <span class="text-secondary whitespace-nowrap text-xs">{{ 'DOCUMENT_GENERATE.COLUMNS.SECONDARY_UOM_LABEL' | t: { value: (alt.umsQty | dgNumber: 'stock') + ' ' + alt.umsCode } }}</span>
                  }
                  @if (alt.umpQty != null) {
                  <span class="text-secondary whitespace-nowrap text-xs">{{ 'DOCUMENT_GENERATE.COLUMNS.PACKAGING_UOM_LABEL' | t: { value: (alt.umpQty | dgNumber: 'stock') + ' ' + alt.umpCode } }}</span>
                  }
                  }
                </div>
              </td>
              <td class="px-4 py-3 text-right font-semibold">
                {{ data.currency }}&nbsp;{{ rowTotal(item) | dgNumber }}
              </td>
            </tr>
            } @empty {
            <tr>
              <td colspan="5">
                <div class="text-secondary flex h-24 items-center justify-center text-sm">
                  {{ 'DOCUMENT_GENERATE.SPLIT_MODAL.EMPTY' | t }}
                </div>
              </td>
            </tr>
            }
          </tbody>
        </table>
      </div>

      <!-- total del documento -->
      <div class="flex items-center justify-end gap-3 border-t px-6 py-3">
        <span class="text-secondary text-sm">{{ 'DOCUMENT_GENERATE.SPLIT_MODAL.DOCUMENT_TOTAL' | t }}</span>
        <span class="text-primary text-lg font-bold">
          {{ data.currency }}&nbsp;{{ selected.summary.total | dgNumber }}
        </span>
      </div>
      }
    </div>
  </div>

  <!-- footer -->
  <div class="flex flex-wrap items-center justify-between gap-3 border-t bg-gray-50 px-6 dark:bg-transparent"
    [ngClass]="shortScreen ? 'py-2' : 'py-4'">
    @if (documentsWithoutRoute.length && data.canGenerateWithoutRoute) {
    <span class="text-secondary text-sm">
      {{ 'DOCUMENT_GENERATE.ROUTE_SPLIT_MODAL.WITHOUT_ROUTE_NOTICE' | t: { count: documentsWithoutRoute.length } }}
    </span>
    } @else {
    <span></span>
    }
    <div class="flex gap-3">
      <button mat-stroked-button type="button" (click)="cancel()">{{ 'GENERAL.CANCEL' | t }}</button>
      <button mat-flat-button color="primary" type="button" [disabled]="!canConfirm" (click)="confirm()">
        {{ 'DOCUMENT_GENERATE.ROUTE_SPLIT_MODAL.CONFIRM' | t }}
      </button>
    </div>
  </div>
</div>
